// Configuration
const DEFAULT_SUBSCRIPTION = 'Deliver every 2 weeks' // Can be changed on: 'One time purchase', 'Deliver every month', 'Deliver every 2 weeks'
console.log('DEFAULT_SUBSCRIPTION is set to:', DEFAULT_SUBSCRIPTION)

// Remove the first initialization block
let subscribeProduct = document.querySelector('.ROS-Continer-2')

setTimeout(() => {
	let imageSlideshowCustomNavigation = document.querySelectorAll(
		'.image--slideshow__custom-navigation a'
	)
	if (imageSlideshowCustomNavigation) {
		imageSlideshowCustomNavigation.forEach(el => {
			el.addEventListener('click', () => {
				let activeThumb = document.querySelector(
					'.product-single__media--selected'
				)
				// console.log(activeThumb);
				if (activeThumb) {
					activeThumb.classList.remove('product-single__media--selected')
				}
			})
		})
	}
	let subscribeProduct = document.querySelector('.ROS-Continer-2')
	if (subscribeProduct) {
		let subscribeButtons = subscribeProduct.querySelectorAll(
			'.ROS-radio-toolbar-2 .ROS-indiWrapper .ROS-sub-radio-main-2'
		)
		let subscribeButtonsAlllabel = subscribeProduct.querySelectorAll(
			'.ROS-radio-toolbar-2 .ROS-js-plan-grp-2 label'
		)
		let subscribeButtonOneTime = document.querySelector(
			'.ROS-Continer-2 [id="sellingplan_no"]'
		)?.parentNode
		let priceProduct = document.querySelector('#ProductPrice .money')

		// Проверяем наличие всех необходимых элементов
		if (
			!subscribeButtons?.length ||
			!subscribeButtonsAlllabel?.length ||
			!subscribeButtonOneTime ||
			!priceProduct
		) {
			console.log('Required elements not found, retrying...')
			return
		}

		let priceProductOneTimePurchase = priceProduct.textContent
		let subscribeButtonsActivate

		// Find Subscribe and save radio button
		subscribeButtonsAlllabel.forEach(element => {
			if (element.textContent == 'Subscribe and save') {
				subscribeButtonsActivate = element.parentNode.querySelector('input')
			}
		})

		// Function to handle subscription selection
		const selectSubscription = buttonElement => {
			// Clear all selections first
			subscribeButtons.forEach(btn => {
				btn.classList.add('unChecken')
				// Снимаем выбор со всех радиокнопок внутри кнопок подписки
				const radio = btn.querySelector('input[type="radio"]')
				if (radio) radio.checked = false
			})

			// Снимаем выбор с one-time purchase
			const oneTimeRadio = subscribeButtonOneTime.querySelector('input')
			if (oneTimeRadio) oneTimeRadio.checked = false

			subscribeButtonsActivate.checked = false

			if (buttonElement) {
				// If selecting a subscription option
				buttonElement.classList.remove('unChecken')
				subscribeButtonsActivate.checked = true
				// Устанавливаем checked для радиокнопки внутри выбранной опции
				const radio = buttonElement.querySelector('input[type="radio"]')
				if (radio) {
					radio.checked = true
					// Проверяем наличие скрытого input для плана подписки
					const planInput = document.querySelector('input[name="selling_plan"]')
					if (planInput) {
						planInput.value = radio.value
					}
				}
				priceProduct.textContent = buttonElement.querySelector(
					'.ROS-sub-main-two span'
				).textContent
			} else {
				// If selecting one-time purchase
				if (oneTimeRadio) {
					oneTimeRadio.checked = true
					// Очищаем значение плана подписки
					const planInput = document.querySelector('input[name="selling_plan"]')
					if (planInput) {
						planInput.value = ''
					}
				}
				priceProduct.textContent = priceProductOneTimePurchase
			}
			animationPrice(priceProduct)
		}

		// Функция очистки всех выделений
		const clearAllSelections = () => {
			// Снимаем выделение со всех кнопок подписки
			subscribeButtons.forEach(btn => {
				btn.classList.add('unChecken')
				const radio = btn.querySelector('input[type="radio"]')
				if (radio) radio.checked = false
			})

			// Снимаем выделение с one-time purchase
			const oneTimeRadio = subscribeButtonOneTime.querySelector('input')
			if (oneTimeRadio) oneTimeRadio.checked = false

			// Снимаем выделение с Subscribe and save
			if (subscribeButtonsActivate) subscribeButtonsActivate.checked = false

			// Очищаем значение плана подписки
			const planInput = document.querySelector('input[name="selling_plan"]')
			if (planInput) planInput.value = ''
		}

		// Немедленно очищаем все выделения
		clearAllSelections()

		// Setup click handlers for subscription options
		subscribeButtons.forEach(element => {
			element.addEventListener('click', () => selectSubscription(element))
		})

		// Setup one-time purchase handler
		subscribeButtonOneTime.addEventListener('click', () =>
			selectSubscription(null)
		)

		// Set initial selection
		if (DEFAULT_SUBSCRIPTION === 'One time purchase') {
			console.log('Selecting one time purchase')
			selectSubscription(null)
		} else {
			console.log('Looking for subscription option:', DEFAULT_SUBSCRIPTION)
			let defaultButton = null

			// Добавляем отладочную информацию о найденных кнопках
			console.log('Found subscription buttons:', subscribeButtons.length)

			subscribeButtons.forEach((element, index) => {
				console.log(`Checking button ${index}:`, element.innerHTML)

				const buttonText = element.textContent.trim()
				// Удаляем лишние пробелы и цены
				const cleanText = buttonText
					.replace(/\s+/g, ' ')
					.replace(/\$[\d.]+/g, '')
					.trim()
				console.log(`Button ${index} cleaned text:`, cleanText)

				if (cleanText.toLowerCase() === DEFAULT_SUBSCRIPTION.toLowerCase()) {
					defaultButton = element
					console.log('Match found - setting default button')
				}
			})

			if (defaultButton) {
				console.log('Setting subscription')
				selectSubscription(defaultButton)
			} else {
				console.log('No matching subscription button found')
				// Выводим все найденные тексты кнопок для сравнения
				console.log('Available subscription options:')
				subscribeButtons.forEach((element, index) => {
					const text = element.textContent.trim()
					console.log(`Option ${index}:`, text)
				})
			}
		}

		function animationPrice(priceProduct) {
			let speed = priceProduct.parentNode.getAttribute('data-scale-speed')
			let size = priceProduct.parentNode.getAttribute('data-scale-size')
			priceProduct.style.transition = `0.${speed}s`
			priceProduct.style.transform = `scale(1.${size})`
			setTimeout(() => {
				priceProduct.style.transform = `scale(1.0)`
			}, 100 * `${speed}`)
		}
	}

	let footer = document.querySelector('footer.footer-main')
	let termsConditionsHeader = footer.querySelector('.footer-header')
	let headerDots = footer.querySelector('.footer-header-dots')
	let contentTermsConditions = termsConditionsHeader.nextElementSibling
	let contentTermsConditionsHeight = contentTermsConditions.scrollHeight

	termsConditionsHeader.style.cursor = 'pointer'
	termsConditionsHeader.addEventListener('click', () => {
		if (contentTermsConditions.classList.contains('active')) {
			contentTermsConditions.classList.remove('active')
			contentTermsConditions.style.maxHeight = 0 + 'px'
			headerDots.style.display = 'block'
		} else {
			contentTermsConditions.classList.add('active')
			contentTermsConditions.style.maxHeight =
				contentTermsConditionsHeight + 'px'
			contentTermsConditions.style.marginLeft = 25 + 'px'
			headerDots.style.display = 'none'
		}
	})
	termsConditionsHeader.click()
	termsConditionsHeader.click()

	if (document.querySelector('body.template-index')) {
		let buttonT1 = document.querySelectorAll('.homepage-section-btn')
		let buttonT2 = document.querySelectorAll('.homepage-featured-box-btn')
		const arrButtons = []
		let longestButton = 0
		buttonT1.forEach(button => {
			arrButtons.push(button)
		})
		buttonT2.forEach(button => {
			arrButtons.push(button)
		})
		arrButtons.forEach(button => {
			//  console.dir(button);
			if (button.clientWidth > longestButton) {
				longestButton = button.clientWidth * 0.8
			}
		})
		arrButtons.forEach(button => {
			button.style.width = longestButton + 'px'
		})
	}
}, 500)

function tryApplyStyles() {
	const appEmbed = document.querySelector('delivery-promise-wc')
	if (appEmbed && appEmbed.shadowRoot) {
		// Found the element and its shadow root, apply the styles

		// Create a style element
		const styleElement = document.createElement('style')

		// Add your CSS rules to the style element
		styleElement.textContent = `
                      .AmazonLayout__amazon-layout.AmazonLayout__--IsControl {
                          background-color: transparent !important;
                          margin-top: 0 !important;
                      }
                      
                      .AmazonLayout__amazon-layout.AmazonLayout__--IsControl {
                          --color-background: transparent;
                          max-width: 253x !important;
                          min-height: 39px;
                          height: 39px;
                      }
                     button svg{
                          width: 90px;
                          margin-top: -3px;
                      }
                      button svg path{
                          fill: black;
                          transition: .4s all;
                      }
                      .AmazonLayout__content-slot{
                          margin: auto;
                          text-align: center;
                      }
                      button.amazon-pay-button {
                          background: transparent;
                          border: 1px solid black;
                          color: black;
                          transition: .4s all;
                      }
                      .amazon-pay-button:hover:enabled{
                          background-color: black;
                          transition: .4s all;
                      } 
                      .amazon-pay-button:hover:enabled svg{
                          fill: white;
                          transition: .4s all;
                      }
                    `

		// Append the style element to the shadow root
		appEmbed.shadowRoot.appendChild(styleElement)
		// console.log('stype apply');
		// Clear the interval as we've successfully applied the styles
		clearInterval(checkInterval)
	}
}

// Set an interval to keep checking for the element

const checkInterval = setInterval(tryApplyStyles, 1000)

function tryApplyStyles2() {
	const appEmbed = document.querySelector('#generic-promise-wc')
	if (appEmbed && appEmbed.shadowRoot) {
		// Found the element and its shadow root, apply the styles

		// Create a style element
		const styleElement = document.createElement('style')

		// Add your CSS rules to the style element
		styleElement.textContent = `
                      .AmazonLayout__amazon-layout.AmazonLayout__--IsControl {
                          background-color: transparent !important;
                          margin-top: 0 !important;
                      }
                      
                      .AmazonLayout__amazon-layout.AmazonLayout__--IsControl {
                          --color-background: transparent;
                          max-width: 253px !important;
                          min-height: 39px !important;
                          height: 39px !important;
                      }
                      
                     button svg{
                          width: 90px !important;
                          margin-top: -3px !important;
                      }
                      
                      button svg path{
                          fill: black !important;
                          transition: .4s all !important;
                      }
                      
                      .AmazonLayout__content-slot{
                          margin: auto !important;
                          text-align: center !important;
                      }
                      
                      button.amazon-pay-button {
                          background: transparent !important;
                          border: 1px solid black !important;
                          color: black !important;
                          max-width: 242px !important;
                          height: 40px !important;
                          transition: .4s all !important;
                      }
                      button.amazon-pay-button:hover svg path{
                          fill: white !important;
                          transition: .4s all !important;
                      }
                      .amazon-pay-button:hover:enabled{
                          background-color: black !important;
                          transition: .4s all !important;
                      }
                      
                      .amazon-pay-button:hover svg path{
                          fill: white !important;
                          transition: .4s all !important;
                      }
                    `

		// Append the style element to the shadow root
		appEmbed.shadowRoot.appendChild(styleElement)
		// console.log('stype apply');
		// Clear the interval as we've successfully applied the styles
		clearInterval(checkInterval2)
	}
}

// Set an interval to keep checking for the element

const checkInterval2 = setInterval(tryApplyStyles2, 1000)
